import FillBlank from "./KrFillBlank.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrFillBlank = install(FillBlank); // 生成带有 install 方法的组件

export default KrFillBlank;
